import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import Typography from "@mui/material/Typography";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { fetchOrgCodeAndValidate } from "./indexedDBHelper";
import LicenseExpiryPopup from "../../components/LicenseExpiryPopup";
import StoragePopUp from "./StoragePopUp";
export default function OrgCodePopup({ open, setOpen }) {
  const history = useHistory();
  const [code, setCode] = useState("");
  const [error, setError] = useState(false);
  const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;
  const [openWarning, setOpenWarning] = useState(false);
  const [expireInDays, setExpireInDays] = useState(null);
  const [openLimitModal, setOpenLimitModal] = useState(false);
  const [limitMessage, setLimitMessage] = useState("");

  const handleOk = () => {
    if (!/^[A-Z0-9]{8}$/.test(code)) {
      setError(true);
      return;
    }
    setError(false);
    validate();
  };

  const validate = () => {
    const apiUrl = `${REACT_APP_BACKEND_ROUTE_URL}validate_organisation/`;
    const requestBody = { ORG_CODE: code };

    axios
      .post(apiUrl, JSON.stringify(requestBody), {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.data.status === "Success") {
          console.log("Success:", response.data);
          setOpen(false);
          // alert("Successfully verified");
          // const request = indexedDB.open("HLTHTEK-DB");

          // request.onupgradeneeded = (event) => {
          //   const db = event.target.result;
          //   if (!db.objectStoreNames.contains("T_ORG")) {
          //     db.createObjectStore("T_ORG");
          //   }
          // };

          // request.onerror = (event) => {
          //   console.error("IndexedDB open failed", event.target.error);
          // };

          // request.onsuccess = (event) => {
          //   const db = event.target.result;
          //   const transaction = db.transaction("T_ORG", "readwrite");
          //   const store = transaction.objectStore("T_ORG");

          //   const orgPut = store.put(code, "ORG_CODE");
          //   orgPut.onsuccess = () => console.log("ORG_CODE saved");
          //   orgPut.onerror = (e) => console.log("Failed to save ORG_CODE", e);

          //   const appPut = store.put(response.data.data.app_mode, "APP_MODE");
          //   appPut.onsuccess = () => console.log("APP_MODE saved");
          //   appPut.onerror = (e) => console.log("Failed to save APP_MODE", e);

          //   transaction.oncomplete = () => {
          //     console.log("Transaction completed: data saved.");
          //   };
          //   transaction.onerror = (e) => {
          //     console.error("Transaction error", e);
          //   };
          // };

          const request = indexedDB.open("HLTHTEK-DB");

          request.onupgradeneeded = (event) => {
            const db = event.target.result;
            if (!db.objectStoreNames.contains("T_ORG")) {
              db.createObjectStore("T_ORG");
            }
          };

          request.onerror = (event) => {
            console.error("IndexedDB open failed", event.target.error);
          };

          request.onsuccess = (event) => {
            const db = event.target.result;
            const transaction = db.transaction("T_ORG", "readwrite");
            const store = transaction.objectStore("T_ORG");

            const orgPut = store.put(code, "ORG_CODE");
            orgPut.onsuccess = () => console.log("ORG_CODE saved");
            orgPut.onerror = (e) => console.log("Failed to save ORG_CODE", e);

            const appPut = store.put(response.data.data.app_mode, "APP_MODE");
            appPut.onsuccess = () => console.log("APP_MODE saved");
            appPut.onerror = (e) => console.log("Failed to save APP_MODE", e);

            transaction.oncomplete = () => {
              console.log("Transaction completed: data saved.");
              db.close(); // Close the connection here
            };

            transaction.onerror = (e) => {
              console.error("Transaction error", e);
              db.close(); // Still close even if there's an error
            };
          };

          fetchOrgCodeAndValidate((data) => {
            if (data) {
              validate2(data);
            } else {
              console.error("Failed to fetch data from IndexedDB.");
            }
          });
        } else {
          setError(true);
          console.log("Verification failed", response.data.message);
        }
      })
      .catch((error) => {
        console.error(
          "API Error:",
          error.response ? error.response.data : error.message
        );
      });
  };

  const validate2 = (data) => {
    const appMode = data.app_mode;
    const apiUrl = `${REACT_APP_BACKEND_ROUTE_URL}validate_license/`;
    const requestBody = { ORG_CODE: code, APP_MODE: appMode };

    axios
      .post(apiUrl, JSON.stringify(requestBody), {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.data.message !== "License Validated") {
          history.push("/License", {
            orgCode: code,
            appMode,
            mac_address: response.data.data.mac_address,
          });
          setError(true);
          console.log("Verification failed", response.data.message);
        } else {
          console.log("Success:", response.data);
          // toast.success(response.data.message);
          // setOpenWarning(true);
          // history.push("/License", {
          //   orgCode: code,
          //   appMode,
          //   mac_address: response.data.data.mac_address,
          // });

          // setOpen(false);
          const expireDaysRaw = response.data?.data?.license_expire_day_count;

          if (typeof expireDaysRaw === "number" && !isNaN(expireDaysRaw)) {
            setExpireInDays(expireDaysRaw);

            if (expireDaysRaw <= 30) {
              setOpenWarning(true);
            } else {
              console.log(
                `License is valid for ${expireDaysRaw} days, no popup shown.`
              );
            }
          } else {
            console.warn(
              "Invalid or missing 'license_expire_day_count' in response."
            );
          }
          const apiUrl = `${REACT_APP_BACKEND_ROUTE_URL}validate_assets_size/`;
          const requestBody = { ORG_CODE: code };
          axios
            .post(apiUrl, requestBody, {
              headers: { "Content-Type": "application/json" },
            })
            .then((response) => {
              if (
                response.data.status === "Failed" 
                // &&
                // response.data.message ===
                //   "Data limit exceeded. Please contact administrator."
                  //  "Data and media limit exceeded. Please contact administrator."
              ) {
                setLimitMessage(response.data.message);
                setOpenLimitModal(true);
              } else {
                console.log(response.data.message);
              }
            });
        }
      })
      .catch((error) => {
        console.error(
          "API Error:",
          error.response ? error.response.data : error.message
        );
      });
  };

  return (
    <>
      <Dialog open={open} disableEscapeKeyDown maxWidth="xs" fullWidth>
        <DialogContent
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "15px",
          }}
        >
          <DialogTitle style={{ fontSize: "1.2rem" }}>
            Validate Organization
          </DialogTitle>
          <div
            className="col-sm-12 col-md-12 col-lg-12"
            // style={{ marginBottom: "10px" }}
          >
            <div className="form-group">
              <input
                name="orgCode"
                type="text"
                className="form-control"
                required={true}
                placeholder="Organization Key"
                value={code}
                onChange={(e) => setCode(e.target.value)}
                style={{
                  width: "60%",
                  textAlign: "center",
                  borderColor: error ? "red" : "",
                  margin: "auto",
                }}
              />
            </div>
          </div>
          <Typography
            variant="body2"
            style={{
              color: "orange",
              textAlign: "center",
              marginBottom: "10px",
            }}
          >
            Every time the app is launched from a new terminal or browser, an
            Organization Key will be required for validation.
          </Typography>
          <div
            className="col-sm-12 col-md-12 col-lg-12"
            style={{ display: "flex", justifyContent: "center" }}
          >
            <button
              className="btn btn__secondary mt-10"
              type="button"
              onClick={handleOk}
              style={{ padding: "3px 6px", fontSize: "1rem" }}
            >
              Validate
            </button>
          </div>
        </DialogContent>
      </Dialog>
      <LicenseExpiryPopup
        open={openWarning}
        setOpen={setOpenWarning}
        expireInDays={expireInDays}
      />
      <StoragePopUp
        open={openLimitModal}
        setOpen={setOpenLimitModal}
        message={limitMessage}
      />
    </>
  );
}
